'use client';

import { EmblaCarouselType } from 'embla-carousel';
import { useState } from 'react';

import {
  CategoryButton,
  UiCategoryButtonBase
} from '@/fo/ui/category/button/base';
import { UiKitCarouselBase } from '@/fo/ui/kit/carousel/base';

import { NavButton } from '../components/NavButton/NavButton';

import { styles } from './UiCategoryCarouselBase.styles';

export interface UiCategoryCarouselBaseProps {
  items: CategoryButton[];
  withoutBorder?: boolean;
  onClick?: (id?: string | number) => void;
}

export function UiCategoryCarouselBase({
  items,
  withoutBorder = true,
  onClick
}: UiCategoryCarouselBaseProps) {
  const slots = styles();
  const [emblaApi, setEmblaApi] = useState<EmblaCarouselType>();

  const handleClick = (item: CategoryButton) => {
    if (!item.active) {
      emblaApi?.scrollTo(0);
    }
    onClick?.(item.id);
  };

  return (
    <div className={slots.base()}>
      <UiKitCarouselBase
        className={slots.carousel()}
        viewportClassName={slots.viewport()}
        loop={false}
        showArrows={false}
        dragFree
        onInit={setEmblaApi}
        renderCustomControls={(controls) => (
          <div className={slots.controls()}>
            <div className={slots.controlsContainer()}>
              <div className={slots.controlsInner()}>
                <NavButton
                  disabled={controls.prevBtnDisabled}
                  onClick={controls.onPrevButtonClick}
                />
                <NavButton
                  disabled={controls.nextBtnDisabled}
                  direction="next"
                  onClick={controls.onNextButtonClick}
                />
              </div>
            </div>
          </div>
        )}
      >
        {items
          .filter((item) => item.active)
          .map((item) => (
            <UiCategoryButtonBase
              size="sm"
              key={item.id}
              item={item}
              withoutImageBorder={withoutBorder}
              onClick={() => handleClick(item)}
              className={slots.button()}
            />
          ))}
        {items
          .filter((item) => !item.active)
          .map((item) => (
            <UiCategoryButtonBase
              size="sm"
              key={item.id}
              item={item}
              withoutImageBorder={withoutBorder}
              onClick={() => handleClick(item)}
              className={slots.button()}
            />
          ))}
      </UiKitCarouselBase>
    </div>
  );
}
